// tiny fetch wrapper with CORS-safe defaults
const API_BASE = process.env.REACT_APP_API_BASE || 'httphttp://localhost:3000';

export async function http(path, { method = 'GET', headers = {}, body } = {}) {
  const token = localStorage.getItem('bagspa_token');
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    mode: 'cors',
    credentials: 'omit', // we are not using cookies anymore
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  // Don’t rely on CORS-exposed headers; read JSON body instead.
  // If the response has no body (204), skip JSON parsing.
  let json;
  try { json = res.status === 204 ? null : await res.json(); } catch (_) {}

  if (!res.ok) {
    const msg = json?.error || json?.message || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return { res, json };
}
